export const TAP_EVENT = 'tap';
export const VIEW_EVENT = 'view';
export const HOTEL_SEARCH = 'aa_htl_search';
export const HOTEL_SEARCH_INITIATED = 'aa_htl_search_initiated';
export const HOTEL_SELECT_HOTEL = 'aa_htl_hotelselect_actions';
export const HOTEL_SELECT_ROOM = 'aa_htl_roomselect_actions';
export const HOTEL_VIEW_ROOM = 'aa_htl_roomsearch_initiated';
export const HOTEL_LEFT_EMPTY_FIELD = 'fieldLeftEmpty';
export const HOTEL_GUEST_DETAIL_LOADED = 'aa_htl_guestdetailspage_loaded';
export const HOTEL_GUEST_DETAIL_SUMMIT = 'aa_htl_guestdetails_submitted';
export const HOTEL_PAYMENT_INITIATED = 'aa_htl_payment_initiated';
export const HOTEL_VIEW_ITEM_LIST = 'view_item_list';
export const HOTEL_ITEM_SELECT = 'select_item';
export const HOTEL_ADD_TO_CART = 'add_to_cart';
export const HOTEL_ADD_PAYMENT_INFO = 'add_payment_info';
export const HOTEL_PURCHASE = 'purchase';
export const HOTEL_BEGIN_CHECKOUT = 'begin_checkout';
export const HOTEL_SELECT_DEFAULT_HOTEL = 'aa_htl_hoteldefaultselect_actions';
export const HOTEL_ROOM_SELECT_MAP = 'aa_htlm_roomselect_actions';
export const TRACK_EVENT_NO_ECOMMERCE = 'trackEventNoEcommerce';
